<template>
  <div class="popup-map">
    <button
      class="popup-map__open"
      :class="floatLinksRight ? 'float-right' : ''"
      @click="open = true"
    >
      {{translate('Näytä kartalla')}}

      <div
        class="popup-map__open-icon"
        :class="[`popup-map__open-icon--${color}`, small ? 'popup-map__open-icon--small' : '']"
      >
        <ChevronIcon />
      </div>
    </button>

    <template v-if="open">
      <button
        class="popup-map__backdrop"
        @click="open = false"
      >
        <span class="popup-map__close">
          <ExIcon />
        </span>
      </button>

      <div class="popup-map__popup">
        <LeafletMap
          :address="encodeURIComponent(address)"
          :language="language"
          :coordinates="coordinates"
          :apiKey="apiKey"
        />
      </div>

    </template>
  </div>
</template>

<script>
  import utils from './mixins/utils';
  //import GoogleMap from './components/GoogleMap';
  import ExIcon from './icons/ExIcon.vue';
  import LeafletMap from './components/LeafletMap';
  import ChevronIcon from './icons/ChevronIcon.vue';


  export default {
    components: {
    //GoogleMap,
    LeafletMap,
    ChevronIcon,
    ExIcon
    },
    mixins: [utils.translate],
    props: {
      color: {
        type: String,
        default: 'default',
      },
      address: {
        type: String,
        required: true,
      },
      coordinates: {
        type: String,
        default: null,
      },
      apiKey: {
        type: String,
        required: true,
      },
      floatLinksRight: {
        type: Boolean,
        default: false,
        required: false,
      },
      language: {
        type: String,
        default: 'fi',
        required: false,
      },
      small: {
        type: Boolean,
        default: false,
        required: false,
      }
    },
    data: () => ({
      open: false,
    }),
    methods: {
      toggle() {
        this.open = !this.open;
      }
    }
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .popup-map {
  }

  .popup-map__open {
    @include reset-button(true);
    @include link();
    display: flex;
    align-items: center;
    justify-content: space-between;

    &.float-right {
      margin-left: auto;
    }

    &:focus {
      text-decoration: underline;
    }
  }

  .popup-map__open-icon {
    margin-left: r(8);
    color: $color-green-2025;

    &--pink {
      color: $color-pink;
    }

    &--yellow {
      color: $color-yellow;
    }

    &--small {
      transform: scale(0.7);
      margin-left: r(4);
    }
  }

  .popup-map__backdrop {
    @include reset-button;
    position: fixed;
    z-index: 200;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color-black, 0.75);
  }

  .popup-map__close {
    @include square(r(64));
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $color-white;
    transition: transform 0.2s;

    .popup-map__backdrop:focus & {
      transform: scale(1.2);
    }
  }

  .popup-map__popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: r(64) r(8) r(8) r(8);
    z-index: 201;

    @include media-breakpoint-up(sm) {
      margin: r(64);
    }
  }

  .popup-map__map {
    border: none;
    width: 100%;
    height: 100%;
  }
</style>
